// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dropdown-menu[data-v-d16d6306]{\n  z-index:99999 !important;\n}\n", ""]);
// Exports
module.exports = exports;
